import { filterListProps } from '@components/exam_result/filter/FilterList';
import { atom } from 'jotai';

export type filterOptionType = { label: string; value: string };
type extendedFilterProps = Pick<filterListProps, 'id' | 'titleList' | 'list'>;

export const selectedFilterOptionAtom = atom({
  subject: 'All',
  level: 'All',
  type: 'All',
});
export const examFilterOptionListAtom = atom<filterOptionType[]>([
  { label: 'All', value: 'All' },
]);
export const subjectFilterOptionListAtom = atom<filterOptionType[]>([
  { label: 'All', value: 'All' },
]);
export const levelFilterOptionListAtom = atom<filterOptionType[]>([
  { label: 'All', value: 'All' },
]);
export const testingAtom = atom({ label: 'All', value: 'All' });

export const showAllFilterAtom = atom(false);
export const extendedFilterAtom = atom<extendedFilterProps | null>(null);
export const showFilterSheetAtom = atom<boolean>(false);

export const studentHasActiveSubscriptionAtom = atom(true);
export const activeSubscriptionSubjectsArrayAtom = atom<
  {
    value: string | number;
    label: string;
  }[]
>([]);
